export const colorsChartTheme6 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    purple: {
        dark: {
            light: "rgba(100, 64, 75, 1)",
            dark: "rgba(125, 92, 102, 1)"
        },
        medium: {
            light: "rgba(145, 92, 109, 1)",
            dark: "rgba(171, 125, 139, 1)"
        },
        light: {
            light: "rgba(175, 131, 145, 1)",
            dark: "rgba(201, 171, 181, 1)"
        },
        darker: {
            light: "rgba(75, 48, 56, 1)",
            dark: "rgba(99, 74, 81, 1)"
        },
        lighter: {
            light: "rgba(199, 168, 178, 1)",
            dark: "rgba(224, 211, 215, 1)"
        },
        disabled: {
            light: "rgba(199, 168, 178, 1)",
            dark: "rgba(224, 211, 215, 1)"
        }
    },
    cyan: {
        medium: {
            light: "rgba(72, 125, 107, 1)",
            dark: "rgba(102, 150, 134, 1)"
        },
        darker: {
            light: "rgba(30, 52, 44, 1)",
            dark: "rgba(52, 76, 68, 1)"
        },
        dark: {
            light: "rgba(45, 78, 67, 1)",
            dark: "rgba(71, 105, 93, 1)"
        },
        light: {
            light: "rgba(125, 181, 162, 1)",
            dark: "rgba(163, 206, 192, 1)"
        },
        lighter: {
            light: "rgba(151, 195, 181, 1)",
            dark: "rgba(191, 219, 210, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(240, 115, 5, 1)",
            dark: "rgba(255, 136, 31, 1)"
        },
        medium: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        },
        dark: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        },
        darker: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(0, 171, 245, 1)",
            dark: "rgba(23, 168, 229, 1)"
        },
        "lighter-weight": {
            light: "rgba(31, 188, 255, 1)",
            dark: "rgba(31, 188, 255, 1)"
        },
        light: {
            light: "rgba(0, 143, 204, 1)",
            dark: "rgba(21, 153, 209, 1)"
        },
        "light-weight": {
            light: "rgba(0, 157, 224, 1)",
            dark: "rgba(25, 183, 250, 1)"
        },
        medium: {
            light: "rgba(0, 114, 163, 1)",
            dark: "rgba(19, 138, 189, 1)"
        },
        dark: {
            light: "rgba(0, 100, 143, 1)",
            dark: "rgba(17, 123, 168, 1)"
        },
        darker: {
            light: "rgba(0, 71, 102, 1)",
            dark: "rgba(13, 93, 128, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(165, 70, 87, 1)",
            dark: "rgba(191, 99, 116, 1)"
        },
        light: {
            light: "rgba(189, 100, 116, 1)",
            dark: "rgba(189, 100, 116, 1)"
        },
        lighter: {
            light: "rgba(196, 114, 129, 1)",
            dark: "rgba(196, 114, 129, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
